<template>
  <div class="unitaire">
    <div class="row">
      <div class="col s6">
        <info id="stock" label="Stock" :value="getStock"></info>
      </div>
      <div class="col s6">
        <info id="position" label="Position en réserve" :value="product.position"></info>
      </div>
    </div>

    <div class="row">
      <div class="col s6">
        <select-number v-bind:max="getStock" v-on:change="quantity = $event" id="quantity" label="Quantité pièce"></select-number>
      </div>

      <div class="col s6">
        <info
          id="price-unit"
          label="Prix pièce"
          :value="(product.price * product.coefficient).toFixed(2)+'€'"
        ></info>
      </div>
    </div>

    <div class="row">
      <div class="col s6">
        <info value="TOTAL"></info>
      </div>
      <div class="col s6">
        <info :value="(product.price * product.coefficient * quantity).toFixed(2)+'€'"></info>
      </div>
    </div>

    <div class="center-align">
      <add-to-basket v-bind:product="product" v-bind:quantity="quantity"></add-to-basket>
    </div>
  </div>
</template>

<script>
import Info from "./Info.vue";
import SelectNumber from "@/components/SelectNumber.vue";
import AddToBasket from "@/components/Product/AddToBasket.vue";

export default {
  props: ["product"],
  data() {
    return {
      quantity: 0
    };
  },
  computed: {
    /* Lorsque la page récupère le produit via l'API, elle ne tient pas compte de la quantité
    qui peut déjà être présente dans le panier. Cette fonction retourne le stock restant en prenant en compte cette quantité.
    */
    getStock: function() {
      var productBasket = this.$store.getters.getProductById(this.product.id);
      if (productBasket) {
        return (
          this.product.stock - productBasket.quantity
        );
      }
      return this.product.stock;
    }
  },
  components: {
    Info,
    SelectNumber,
    AddToBasket
  }
};
</script>
